import React, { createContext, useContext, useEffect, useState } from "react";
import { getContent, UI } from "./content";

const LanguageContext = createContext(null);

const STORAGE_KEY = "inexponens_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === "en" ? "en" : "fr";
    } catch {
      return "fr";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    } catch {
      // ignore
    }
  }, [lang]);

  const value = {
    lang,
    setLang,
    toggleLang: () => setLang((l) => (l === "fr" ? "en" : "fr")),
    t: UI[lang],
    data: getContent(lang),
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
